import script from "./Pendency.vue?vue&type=script&setup=true&lang=js"
export * from "./Pendency.vue?vue&type=script&setup=true&lang=js"

import "./Pendency.vue?vue&type=style&index=0&id=1fab1f99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fab1f99"]])

export default __exports__